import React from "react"
import { Avatar as AntdAvatar } from "antd"
import { UserOutlined } from "@ant-design/icons"
import type { AvatarProps } from "antd/lib/avatar"

export const Avatar = (props: AvatarProps): JSX.Element => {
  return <AntdAvatar size="small" shape="square" icon={<UserOutlined />} {...props} />
}
